import { useEffect, useState, useCallback } from "react";
import { getAccountsUser, MODULE_ORDER } from "../services/modulesApi";
import { savePrefs, errMsg } from "../services/accountApi";

// 2026-10-26 (owner): per-person order of the tool cards / Switch-tool menu. Stored server-side in users.prefs.tool_order (NEW FIELD),
// read from the signed-in user object (same path as stylePrefs.js). Unknown ids dropped; tools missing from the saved list are appended
// in MODULE_ORDER order so newly added tools still show. ONE rule - launcher and header menu both call orderTools().
const listeners = new Set();
const notify = () => listeners.forEach((f) => f());

export function orderTools(saved) {
  const out = [];
  for (const t of Array.isArray(saved) ? saved : []) if (MODULE_ORDER.includes(t) && !out.includes(t)) out.push(t);
  for (const t of MODULE_ORDER) if (!out.includes(t)) out.push(t);
  return out;
}
const current = () => { const u = getAccountsUser(); return orderTools(u && u.prefs && u.prefs.tool_order); };
const same = (a, b) => a.length === b.length && a.every((x, i) => x === b[i]);

export function useToolOrder(showToast) {
  const [order, setOrder] = useState(current);
  useEffect(() => {
    const fn = () => setOrder(current());
    listeners.add(fn); fn();
    return () => { listeners.delete(fn); };
  }, []);
  // next = full ordered id list (or [] to reset to the default order). Optimistic; reverts + error toast on failure.
  const save = useCallback(async (next) => {
    const u = getAccountsUser();
    if (!u) return;
    const target = orderTools(next);
    const prevRaw = u.prefs && u.prefs.tool_order;
    if (same(target, current())) return;
    u.prefs = { ...(u.prefs || {}), tool_order: target };
    notify();
    try {
      const r = await savePrefs({ tool_order: next.length ? target : [] });
      u.prefs = { ...(u.prefs || {}), ...(r.prefs || {}) };
      notify();
    } catch (e) {
      console.error("[prefs] tool_order not saved", e);
      u.prefs = { ...(u.prefs || {}), tool_order: prevRaw };
      notify();
      if (showToast) showToast(errMsg(e, "Could not save your tool order"), "error");
    }
  }, [showToast]);
  return [order, save];
}
